import angular from 'angular'
import template from './view/buyerTemplate.html'
import { buyer } from 'redevConfig'

const list = (buyer && buyer.list) || ''
const add = (buyer && buyer.add) || ''

const entryPage = list ? require(`redevelopment/outputManage/buyer/${list.templateName}`) : require('./view/buyerList.html')
const buyerListCtrl = list ? require(`redevelopment/outputManage/buyer/${list.controllerName}`) : require('./buyerListCtrl')

const editPage = add ? require(`redevelopment/outputManage/buyer/${add.templateName}`) : require('./view/editBuyer.html')
const editBuyerCtrl = add ? require(`redevelopment/outputManage/buyer/${add.controllerName}`) : require('./editBuyerCtrl')

function config($stateProvider) {
    $stateProvider
        .state('outputManage.ovat.buyer', {
            url: '/buyer',
            template,
            abstract: true,
            title: '购方管理',
            default: 'outputManage.ovat.buyer.list',
        })
        .state('outputManage.ovat.buyer.list', {
            url: '/list',
            template: entryPage,
            controller: 'buyerListCtrl',
        })
        .state('outputManage.ovat.buyer.add', {
            url: '/add',
            template: editPage,
            controller: 'editBuyerCtrl',
            title: '新增',
        })
        .state('outputManage.ovat.buyer.edit', {
            url: '/edit/:customerId',
            template: editPage,
            controller: 'editBuyerCtrl',
            title: '编辑',
        })
}
export default angular
    .module('outputManage.ovat.buyer', [])
    .config(['$stateProvider', config])
    .controller('buyerListCtrl', buyerListCtrl.default)
    .controller('editBuyerCtrl', editBuyerCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/baseData/buyer/index.js